export const part1 = [
  "All posts",
  "Artists",
  "News",
  "Downloads",
  "Tutorials",
  "Videos",
  "Loop",
];

export const part2 = [
  {
    link: "https://cdn-resources.ableton.com/resources/uploads/zinnia/thumb_52340500443_84c2fc35b4_o_800x400px.jpg.600x340_q85_crop_upscale.jpg",
    name: "Downloads",
    color: "bg-red-400",
    content: "Ah! Kosmos & Hainbach: Blasting The Sirens",
  },
  {
    link: "https://cdn-resources.ableton.com/resources/uploads/zinnia/thumb_meld-1_DSC1794_CROP_800x400px.jpg.600x340_q85_crop_upscale.jpg",
    name: "Artists",
    color: "bg-yellow-400",
    content: "Deena Abdelwahed: Confounding Expections",
  },
  {
    link: "https://cdn-resources.ableton.com/resources/uploads/zinnia/thumb_ABL_End_of_Year_Collage_EN_1.jpg.600x340_q85_crop_upscale.jpg",
    name: "News",
    color: "bg-violet-400",
    content:
      "Robots, Rhythms and  Creatvie Reinvention: Eight Features and Videos from 2023",
  },
];

export const part3 = [
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/NL_Spitfire_Choir.jpg?",
    content: "Expressive Choir by Spitfire Audio >",
  },
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/TN_Building_Max_Devices.jpg?",
    content: "Building Max Devices by Ableton >",
  },
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/BL_SPAT_Devices.jpg?",
    content: "SPAT Bundle by Music Unit >",
  },
];

export const part4 = [
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/Screenshot_2023-04-11_at_12.20.55.png?",
    content: "Learn the foundations of music >",
  },
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/403_Product_Takeover5.jpg?",
    content: "Get started with Live >",
  },
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/Screenshot_2023-04-11_at_12.22.04.png?",
    content: "Go further with Live and Push tutorials>",
  },
];

export const part5 = [
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/One_Thing_I_Am_Snow_Angel_Title.jpg?",
    content: "Reverse vocal intros >",
  },
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/One_Thing_Splendore_Title.jpg?",
    content: "Transformations >",
  },
  {
    link: "https://ableton-production.imgix.net/uploads/content-clusters/One_Thing_JWords_Title.jpg?",
    content: "Alternating rhythms >",
  },
];

export const part6 = [
  "All posts",
  "Artists",
  "News",
  "Downloads",
  "Tutorials",
  "Videos",
  "Loop",
  "One Thing",
];
